import { useNavigate } from 'react-router-dom';

type Props = {
  title: string;
  back?: boolean;
  right?: React.ReactNode;
};

export default function TopBar({ title, back, right }: Props) {
  const nav = useNavigate();
  return (
    <header
      className="sticky top-0 px-4 flex items-center gap-3 shadow-sm"
      style={{ backgroundColor: '#dedede', borderBottom: '1px solid #c8c8c8', paddingTop: 'calc(env(safe-area-inset-top) + 12px)', paddingBottom: '12px', zIndex: 800 }}
    >
      {back && (
        <button
          onClick={() => window.history.length > 1 ? nav(-1) : nav('/')}
          className="flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-xl text-base"
          style={{ backgroundColor: 'rgba(100,116,139,0.13)', border: '1px solid rgba(100,116,139,0.22)', color: '#64748b' }}
          aria-label="Volver"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
      )}
      <h1 className="flex-1 font-bold text-lg truncate" style={{ color: '#303030' }}>{title}</h1>
      {right}
    </header>
  );
}
